/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type EventSummaryContainer_node$ref = any;
export type BookingStatus = "BOOKED" | "CANCELED" | "INITIAL" | "%future added value";
export type UserEventVisibility = "HIDDEN" | "SHOW" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type EventShowContainer_node$ref: FragmentReference;
export type EventShowContainer_node = {|
  +id: string,
  +start_at: ?any,
  +end_at: ?any,
  +all_day: ?boolean,
  +time_zone: ?string,
  +title: ?string,
  +can_edit: ?boolean,
  +user_event: ?{|
    +id: string,
    +booking_status: ?BookingStatus,
    +visibility: ?UserEventVisibility,
    +start_at: ?any,
    +end_at: ?any,
    +time_zone: ?string,
  |},
  +workspaces: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +contracts: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +title: ?string,
            |}
          |}>
        |},
        +estimates: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +title: ?string,
            |}
          |}>
        |},
        +forms: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +title: ?string,
            |}
          |}>
        |},
        +invoices: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +title: ?string,
            |}
          |}>
        |},
        +music_planners: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +title: ?string,
            |}
          |}>
        |},
      |}
    |}>
  |},
  +$fragmentRefs: EventSummaryContainer_node$ref,
  +$refType: EventShowContainer_node$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "count": null,
  "cursor": null,
  "direction": "forward",
  "path": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "start_at",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "end_at",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "time_zone",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v7 = [
  v1,
  v5,
  v6
],
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Fragment",
  "name": "EventShowContainer_node",
  "type": "Event",
  "metadata": {
    "connection": [
      v0,
      v0,
      v0,
      v0,
      v0,
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "workspaces"
        ]
      }
    ]
  },
  "argumentDefinitions": [],
  "selections": [
    v1,
    v2,
    v3,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "all_day",
      "args": null,
      "storageKey": null
    },
    v4,
    v5,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "can_edit",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "user_event",
      "storageKey": null,
      "args": null,
      "concreteType": "UserEvent",
      "plural": false,
      "selections": [
        v1,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "booking_status",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "visibility",
          "args": null,
          "storageKey": null
        },
        v2,
        v3,
        v4
      ]
    },
    {
      "kind": "LinkedField",
      "alias": "workspaces",
      "name": "__EventShowContainer_workspaces_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "WorkspaceConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "WorkspaceEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Workspace",
              "plural": false,
              "selections": [
                v1,
                v5,
                {
                  "kind": "LinkedField",
                  "alias": "contracts",
                  "name": "__EventShowContainer_contracts_connection",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "ContractConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "ContractEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "Contract",
                          "plural": false,
                          "selections": v7
                        },
                        v8
                      ]
                    },
                    v9
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": "estimates",
                  "name": "__EventShowContainer_estimates_connection",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "EstimateConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "EstimateEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "Estimate",
                          "plural": false,
                          "selections": v7
                        },
                        v8
                      ]
                    },
                    v9
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": "forms",
                  "name": "__EventShowContainer_forms_connection",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "FormConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "FormEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "Form",
                          "plural": false,
                          "selections": v7
                        },
                        v8
                      ]
                    },
                    v9
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": "invoices",
                  "name": "__EventShowContainer_invoices_connection",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "InvoiceConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "InvoiceEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "Invoice",
                          "plural": false,
                          "selections": v7
                        },
                        v8
                      ]
                    },
                    v9
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": "music_planners",
                  "name": "__EventShowContainer_music_planners_connection",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "MusicPlannerConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "MusicPlannerEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "MusicPlanner",
                          "plural": false,
                          "selections": v7
                        },
                        v8
                      ]
                    },
                    v9
                  ]
                },
                v6
              ]
            },
            v8
          ]
        },
        v9
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "EventSummaryContainer_node",
      "args": null
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '3d6fd0c0b121a22f01f17cf66914d4c1';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Event/Show/__generated__/EventShowContainer_node.graphql.js